module.exports = __webpack_public_path__ + "img/chengdesc2.456c7729.jpg";